const address = {
    type: 'PRIMARY',
    addressLine1: '710 Mariners Island Blvd',
    addressLine2: 'Apt 210',
    city: 'San Mateo',
    region: 'CA',
    postalCode: '94404',
    country: 'United States'
};
const recipient = {
    firstName: 'John',
    lastName: 'Smith',
    maskedID: '123',
    address
};
const statements = [
    {
        id: '1',
        accountID: 'Account1',
        periodFrom: '2020-08-01',
        periodTo: '2020-08-31',
        version: 1,
        recipient,
        productCategory: 'CD',
        productBank: 'Product Bank 1',
        productName: 'Product Name',
        openingBalance: 500.64,
        closingBalance: 501.28,
        custodianBank: { name: 'Central Bank of Kansas City' },
        interestRate: 1.5,
        apyEarned: 1.51,
        interestYTD: 1.28,
        transactions: [
            {
                date: '2020-08-31',
                type: 'INTEREST_POSTING',
                credits: 0.64,
                debits: 0,
                fees: 0,
                balance: 0
            }
        ]
    },
    {
        id: '3',
        accountID: 'Account3',
        periodFrom: '2020-08-01',
        periodTo: '2020-08-31',
        version: 1,
        recipient,
        productCategory: 'CD',
        productBank: 'Product Bank 3',
        productName: 'Product Name 3',
        openingBalance: 1000000,
        closingBalance: 0,
        custodianBank: { name: 'Lewis & Clark Bank' },
        interestRate: 2.5,
        apyEarned: 2.53,
        interestYTD: 6800.0,
        transactions: [
            {
                date: '2020-08-21',
                type: 'INTEREST_POSTING',
                credits: 6800.0,
                debits: 0,
                fees: 0,
                balance: 0
            },
            {
                date: '2020-08-21',
                type: 'FEE',
                credits: 0,
                debits: 0,
                fees: 15.0,
                balance: 0
            },
            {
                date: '2020-08-21',
                type: 'WITHDRAWAL',
                credits: 0,
                debits: 106785.0,
                fees: 0,
                balance: 0
            }
        ]
    },
    {
        id: '5',
        accountID: 'Account5',
        periodFrom: '2020-08-01',
        periodTo: '2020-08-31',
        version: 1,
        recipient,
        productCategory: 'NPCD',
        productBank: 'Product Bank 5',
        productName: 'Product Name',
        openingBalance: 300.0,
        closingBalance: 0,
        custodianBank: { name: 'Starion Bank' },
        interestRate: 3.7,
        apyEarned: 3.77,
        interestYTD: 0.43,
        transactions: [
            {
                date: '2020-08-14',
                type: 'INTEREST_POSTING',
                credits: 0.43,
                debits: 0,
                fees: 0,
                balance: 0
            },
            {
                date: '2020-08-14',
                type: 'WITHDRAWAL',
                credits: 0,
                debits: 300.43,
                fees: 0,
                balance: 0
            }
        ]
    },
    {
        id: '2',
        accountID: 'Account2',
        periodFrom: '2020-09-01',
        periodTo: '2020-09-30',
        version: 1,
        recipient,
        productCategory: 'CD',
        productBank: 'Product Bank 2',
        productName: 'Product Name 2',
        openingBalance: 0,
        closingBalance: 500.66,
        custodianBank: { name: 'Central Bank of Kansas City' },
        interestRate: 3.0,
        apyEarned: 3.04,
        interestYTD: 0.66,
        transactions: [
            {
                date: '2020-09-15',
                type: 'PURCHASE',
                credits: 500.0,
                debits: 0,
                fees: 0,
                balance: 0
            },
            {
                date: '2020-09-31',
                type: 'INTEREST_POSTING',
                credits: 0.66,
                debits: 0,
                fees: 0,
                balance: 0
            }
        ]
    },
    {
        id: '6',
        accountID: 'Account6',
        periodFrom: '2020-09-01',
        periodTo: '2020-09-30',
        version: 1,
        recipient,
        productCategory: 'Savings',
        productBank: 'Product Bank 6',
        productName: 'Product Name 2',
        openingBalance: 0,
        closingBalance: 300690.0,
        custodianBank: { name: 'Lewis & Clark Bank' },
        interestRate: 2.7,
        apyEarned: 2.73,
        interestYTD: 690.0,
        transactions: [
            {
                date: '2020-09-2',
                type: 'PURCHASE',
                credits: 300000.0,
                debits: 0,
                fees: 0,
                balance: 0
            },
            {
                date: '2020-09-19',
                type: 'FEE',
                credits: 0,
                debits: 0,
                fees: 15.0,
                balance: 0
            },
            {
                date: '2020-09-31',
                type: 'INTEREST_POSTING',
                credits: 690.0,
                debits: 0,
                fees: 0,
                balance: 0
            }
        ]
    }
];
export default statements;
